import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../contexts/AuthContext";
import { LanguageContext } from "../contexts/LanguageContext";
import logo from "../assets/images/logo.png";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate } from "react-router-dom";

const TypewriterEffect = () => {
  const { translations } = useContext(LanguageContext);
  const [currentMessage, setCurrentMessage] = useState("");
  const [index, setIndex] = useState(0);
  const [charIndex, setCharIndex] = useState(0);

  useEffect(() => {
    if (!translations.messages || translations.messages.length === 0) return;

    if (index < translations.messages.length) {
      if (charIndex < translations.messages[index].length) {
        const timeout = setTimeout(() => {
          setCurrentMessage((prev) => prev + translations.messages[index][charIndex]);
          setCharIndex(charIndex + 1);
        }, 50);
        return () => clearTimeout(timeout);
      } else {
        const pause = setTimeout(() => {
          setCharIndex(0);
          setCurrentMessage("");
          setIndex((prev) => (prev + 1) % translations.messages.length);
        }, 2000);
        return () => clearTimeout(pause);
      }
    }
  }, [index, charIndex, translations.messages]);

  return <p className="text-center px-4">{currentMessage}</p>;
};

const LoginPage = ({ successMessage }) => {
  
  const navigate = useNavigate();
  const { login } = useContext(AuthContext);
  const { translations, changeLanguage } = useContext(LanguageContext);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    const response = await login(email, password);
    setLoading(false);

    if (response.success) {
      navigate("/chat/home"); 
    } else {
      setErrorMessage(response.message);
    }
  };

  const handleRedirect = (_path) => {
    navigate(_path); // "About" sayfasına yönlendirme
  };

  return (
    <div className="container-fluid vh-100 d-flex align-items-center justify-content-center bg-light">
      <div className="row w-100 h-100">
        {/* Sol Panel */}
        <div className="col-lg-6 d-none d-lg-flex flex-column align-items-center justify-content-center text-white bg-dark">
          <h1 className="display-4 fw-bold">{translations.welcome}</h1>
          <TypewriterEffect />
          <p className="text-center">{translations.discover}</p>
        </div>

        {/* Sağ Panel */}
        <div className="col-lg-6 d-flex flex-column align-items-center justify-content-center bg-light">
          <div className="text-center mb-4">
            <img src={logo} alt="Company Logo" style={{ maxWidth: "150px" }} className="img-fluid" />
          </div>
          <div className="card p-4 shadow" style={{ maxWidth: "400px", width: "100%" }}>
            <h2 className="text-center mb-4">{translations.login}</h2>
            <form onSubmit={handleLogin}>
              <div className="mb-3">
                <label htmlFor="email" className="form-label">
                  {translations.email}
                </label>
                <input
                  type="email"
                  id="email"
                  className="form-control"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  placeholder={translations.email}
                />
              </div>
              <div className="mb-3">
                <label htmlFor="password" className="form-label">
                  {translations.password}
                </label>
                <input
                  type="password"
                  id="password"
                  className="form-control"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  placeholder={translations.password}
                />
              </div>
              {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}
              <button type="submit" className="btn btn-primary w-100" disabled={loading}>
                {loading ? "Loading..." : translations.login}
              </button>
            </form>

            {/* Ekstra Butonlar */}
            <div className="text-center mt-4">
              <button
                className="btn btn-outline-secondary w-100 mb-2"
                onClick={() => handleRedirect("/chat/forgot-password")}
              >
                {translations.forgotPassword}
              </button>
              <button
                className="btn btn-outline-primary w-100"
                onClick={() => handleRedirect("/chat/signup")}
              >
                {translations.createAccount}
              </button>
            </div>

            {/* Dil Değiştirme */}
            <div className="text-center mt-3">
              <hr />
              <div className="d-flex justify-content-center">
                <button
                  className="btn btn-link"
                  onClick={() => changeLanguage("tr")}
                >
                  Türkçe
                </button>
                <button
                  className="btn btn-link"
                  onClick={() => changeLanguage("en")}
                >
                  English
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;